/**
 * @generated SignedSource<<92afe186d9b368435be95e66008a5b86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavProfile_viewer$data = {
  readonly presenceFeatureFlag: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"useIsSellerOnline_viewer">;
  readonly " $fragmentType": "NavProfile_viewer";
};
export type NavProfile_viewer$key = {
  readonly " $data"?: NavProfile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavProfile_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": "presenceFeatureFlag",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "presence"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"presence\")"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavProfile_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useIsSellerOnline_viewer",
      "selections": [
        (v0/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "50a21aa7f3e8d0f513246522f0be3be1";

export default node;
